import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import api from '@/shared/api';
import config from '@/config';
import classNames from 'classnames';
import { listItemMsg } from '@/shared/components/FormattedListValue';

import messages from '@/modules/tasks/taskMessages';

class TaskTemplateFilter extends Component {
  static propTypes = {
    onMainTaskTemplateChanged: PropTypes.func.isRequired,
    onSubTaskTemplateChanged: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    showValidation: PropTypes.bool,
    mainTaskTemplateId: PropTypes.string,
    subTaskTemplateId: PropTypes.string,
    showSubtaskFilter: PropTypes.bool,
  };
  static defaultProps = {
    showSubtaskFilter: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      mainTaskTemplates: [],
      subTaskTemplates: [],
      mainTaskTemplateId: props.mainTaskTemplateId,
      subTaskTemplateId: props.subTaskTemplateId,
      showValidation: props.showValidation,
    };
  }

  componentDidMount() {
    const { intl } = this.props;
    const { mainTaskTemplateId } = this.state;

    api.base.get(`${config.appUrls.tasks}/api/TaskTemplates`).then(({ data }) => {
      const translatedTemplates = data
        .map(t => ({
          ...t,
          label: intl.formatMessage(listItemMsg('taskTemplate', t.id, t.name)), // Map translation to label property
        }))
        .sort((a, b) => (a.label > b.label) - (a.label < b.label)); // Sort on label property

      this.setState(state => ({
        ...state,
        mainTaskTemplates: translatedTemplates,
      }));
    });

    if (mainTaskTemplateId !== undefined) {
      api.base
        .get(`${config.appUrls.tasks}/api/TaskTemplates/children/${mainTaskTemplateId}`)
        .then(({ data }) => {
          const translatedTemplates = data
            .map(t => ({
              ...t,
              label: intl.formatMessage(listItemMsg('taskTemplate', t.id, t.name)), // Map translation to label property
            }))
            .sort((a, b) => (a.label > b.label) - (a.label < b.label)); // Sort on label property

          this.setState(state => ({
            ...state,
            subTaskTemplates: translatedTemplates,
          }));
        });
    }
  }

  mainTaskTemplateChanged = event => {
    const templateId = event.target.value;
    const { intl, onMainTaskTemplateChanged } = this.props;
    if (templateId) {
      api.base
        .get(`${config.appUrls.tasks}/api/TaskTemplates/children/${templateId}`)
        .then(({ data }) => {
          const translatedTemplates = data
            .map(t => ({
              ...t,
              label: intl.formatMessage(listItemMsg('taskTemplate', t.id, t.name)), // Map translation to label property
            }))
            .sort((a, b) => (a.label > b.label) - (a.label < b.label)); // Sort on label property

          this.setState(state => ({
            ...state,
            subTaskTemplates: translatedTemplates,
            mainTaskTemplateId: templateId,
          }));

          onMainTaskTemplateChanged(templateId);
        });
    } else {
      this.setState(state => ({
        ...state,
        subTaskTemplates: [],
        mainTaskTemplateId: templateId,
      }));
      onMainTaskTemplateChanged(templateId);
    }
  };

  subTaskTemplateChanged = event => {
    const templateId = event.target.value;
    const { onSubTaskTemplateChanged } = this.props;

    this.setState(state => ({
      ...state,
      subTaskTemplateId: templateId,
    }));

    onSubTaskTemplateChanged(templateId);
  };

  render() {
    const { intl, showValidation, showSubtaskFilter } = this.props;
    const {
      mainTaskTemplates,
      subTaskTemplates,
      mainTaskTemplateId,
      subTaskTemplateId,
    } = this.state;

    const mainTaskTemplateClassName = classNames('form-group', {
      'has-error': !mainTaskTemplateId && showValidation,
    });

    const subTaskTemplateClassName = classNames('form-group', {
      'has-error': !subTaskTemplateId && showValidation,
    });

    return (
      <div>
        <div className={mainTaskTemplateClassName}>
          <label className="control-label col-md-4">{intl.formatMessage(messages.MainTask)}</label>
          <div className="col-md-8">
            <select
              value={mainTaskTemplateId}
              onChange={this.mainTaskTemplateChanged}
              className="form-control"
            >
              <option value="">{intl.formatMessage(messages.SelectTask)}</option>
              {mainTaskTemplates.map(template => (
                <option key={template.id} value={template.id}>
                  {template.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        {showSubtaskFilter && (
          <div>
            <div className={subTaskTemplateClassName}>
              <label className="control-label col-md-4">
                {intl.formatMessage(messages.Subtask)}
              </label>
              <div className="col-md-8">
                <select
                  value={subTaskTemplateId}
                  onChange={this.subTaskTemplateChanged}
                  className="form-control"
                >
                  <option value="">{intl.formatMessage(messages.SelectTask)}</option>
                  {subTaskTemplates.map(template => (
                    <option key={template.id} value={template.id}>
                      {template.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(TaskTemplateFilter);
